import { render, staticRenderFns } from "./MatchedDocument.vue?vue&type=template&id=59c6fd91&"
import script from "./MatchedDocument.vue?vue&type=script&lang=ts&"
export * from "./MatchedDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports